import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { Select } from 'antd';
import AcknowledgementLayout from "../../../Containers/common/acknowledgement";
import CloseIcon from "../../../Assets/images/close.svg";
import {TertiaryButton} from "../../Common/button";
import UploadAttachments from "../../../Containers/common/uploadAttachment";
import messages from "./messages";
import {LANGUAGE} from "../../../constant";


class UpdatePharmacyStatus extends Component {
  constructor(props) {
    super(props);
      this.state = {
	  loading:false,
	  reasonDocument:""
	  
    };
  }


    updateStatus = async () => {
	this.setState({loading:true});
	const {reasonDocument} = this.state;
	const {data, reassignPharmacy, close, getPharmacies} = this.props;
	const {onSuccess, pharmacies, selectedBranch: distributor_branch_id, defaultPerPage, pageNo, city, pharmacyId, pharmacyName, status:pharmacyStatus, branchValue} = data;
	let intDefaultPerPage = parseInt(defaultPerPage, 10);
	let intPageNo = parseInt(pageNo, 10);

	const attachments = [];
	for(const file of reasonDocument){
	    const {file_path, originalname} = file;
	    attachments.push({file_path, originalname});
	}

	const pharmacyIds = pharmacies.map((pharmacy, index)=>{
	    const pharmacyId = pharmacy.split("-")[1];
	    return pharmacyId;
	});
	
	reassignPharmacy({pharmacyIds, distributor_branch_id, attachments}).then(response=>{
	    const {status} = response;
	    this.setState({loading:false});
	    if(status){
		let data = {};
		if (city) {
		    data.city_id = city;
		}
		if (pharmacyId) {
		    data.pharmacy_id = pharmacyId;
		}
		
		if (pharmacyName) {
		    data.pharmacy_name = pharmacyName;
		}
		if (status) {
		    data.pharmacy_status_id = pharmacyStatus;
		}
		if (branchValue) {
		    data.branch_id = branchValue;
		}
		data.countPerPage = intDefaultPerPage;
		data.pageNo = intPageNo;
		getPharmacies(data);
		onSuccess();
		close();
	    }
	});
	
    }


    uploadHandler = (data) => {
	this.setState({reasonDocument:data});
    }

    deleteUpload = () => {
	this.setState({reasonDocument:""});
    }
    
    
    formatMessage = data => this.props.intl.formatMessage(data);
   
    showStatusUI = () => {

	const {close, lang} = this.props;
	const {formatMessage,  uploadHandler, deleteUpload} = this;
	const { status, reasonDocument } = this.state;
	
	let selectIcon;
	if(lang===LANGUAGE.ARAB){
	    selectIcon="ant-select-arrow-rtl";
	}
	else{
	    selectIcon="ant-select-arrow-ltr";
	}
	
	return (
		<div>
		<div className="flex justify-content-end  mt30 mr40 ml40 clickable" onClick={close}>
		<img src={CloseIcon} alt="close modal"/>
		</div>

		<div className="flex justify-content-center">
		<UploadAttachments fieldType={"reasonDocument"} placeHolder={formatMessage(messages.reasonDoc)} width={"w60"}  uploadHandler={uploadHandler} deleteUpload={deleteUpload} multiple={true} type={"async"}/>
		</div>
	    
		<div className="flex justify-content-center align-items-center mt20">
		<TertiaryButton
	    text={formatMessage(messages.yes)}
            width="wpx120"
	    marginLeft="ml20"
	    marginRight="mr20"
	    handleOnClick={this.updateStatus}
	    disabled={!reasonDocument}
		/>
		</div>
		</div>
	);
    }
    

    render() {
	const {show} = this.props;
	if(!show){
	    return null;
	}

    return (
	    <AcknowledgementLayout>
	    {this.showStatusUI()}
	    </AcknowledgementLayout>
    );
  }
}

export default injectIntl(UpdatePharmacyStatus);
